import clsx from 'clsx';

import { SearchHit } from '@/lib/models/Search';
import { useClientTranslation } from '@/lib/i18n/client';
import { ResultSearchItemWrapper } from '@/shared/SearchDropdown/components/ResultSearchItemWrapper';

import styles from './SearchDropdownTopSearches.module.scss';

interface SearchDropdownTopSearchesProps {
  topSearches: SearchHit[] | null;
}

export function SearchDropdownTopSearches({ topSearches }: SearchDropdownTopSearchesProps) {
  const { t } = useClientTranslation('search');

  return (
    <>
      <div className={clsx(styles.searchHeader, 'text text-sm')}>{t('topSearches')}</div>
      <div className={clsx(styles.contentSearchList, 'text')}>
        {topSearches?.map((hit) => (
          <ResultSearchItemWrapper url={hit.url} key={hit.objectID}>
            <div className={styles.topSearchItem}>
              <h5 className={clsx(styles.title, 'h5')}>{hit.title}</h5>
              <div className={styles.arrow}>→</div>
            </div>
          </ResultSearchItemWrapper>
        ))}
      </div>
    </>
  );
}
